import React, { useContext } from 'react'

import { Tabs as Tabslist, Context } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function Tabs({ list = EMPTY_ARRAY }) {
  const { currentPathname } = useContext(Context)
  const splitPathname = currentPathname.split('/').filter((name) => !!name)
  const tabs = list.map(({ slug, title }) => {
    return {
      id: `/blog/${slug}`,
      title,
    }
  })

  const mergedTabs = [
    { id: '/blog', title: 'All' },
    ...tabs,
  ]
  const activeTab = splitPathname.length > 1
    ? tabs.find(({ id }) => id === currentPathname)?.id
    : ''

  return (
    <Tabslist
      className="blog-tabs"
      wrapperClassName="blog-page-tabs"
      activeTabId={activeTab}
      tabs={mergedTabs}
      onClick={(tab) => {
        window.location = tab
      }}
    />
  )
}

Tabs.propTypes = {
  list: array,
}

export default Tabs
